import {
    getPollsFilterRepo, getPollsListRepo, postPollsRepo , putPollsRepo, getPollsRepo,deletePollsRepo, getCommentModerationFilterRepo, getCommentModerationListRepo, getCommentModerationEditRepo, putCommentModerationSubmitRepo,
} from "../../repositories/polls";
import {
    getPollTitleFilterLoading,
    getPollTitleFilterSuccess,
    getPollTitleFilterFailure,

    getPollStatusFilterLoading,
    getPollStatusFilterSuccess,
    getPollStatusFilterFailure,

    getPollDeviceFilterLoading,
    getPollDeviceFilterSuccess,
    getPollDeviceFilterFailure,

    getPollPageTypeFilterLoading,
    getPollPageTypeFilterSuccess,
    getPollPageTypeFilterFailure,

    getPollEntityTypeFilterLoading,
    getPollEntityTypeFilterSuccess,
    getPollEntityTypeFilterFailure,

    getPollEntityNameFilterLoading,
    getPollEntityNameFilterSuccess,
    getPollEntityNameFilterFailure,

    getPollSubCategoryFilterLoading,
    getPollSubCategoryFilterSuccess,
    getPollSubCategoryFilterFailure,

    getPollsListLoading,
    getPollsListSuccess,
    getPollsListFailure,

    postPollLoading,
    postPollsSuccess,
    postPollsFailure,

    putPollsLoading,
    putPollsSuccess,
    putPollsFailure,

    getPollDomainTypeLoading,
    getPollDomainTypeSuccess,
    getPollDomainTypeFailure,

    getPollSubPageLoading,
    getPollSubPageSuccess,
    getPollSubPageFailure,

    getPollsDataLoading,
    getPollsDataSuccess,
    getPollsDataFailure,

    deletePollsDataLoading,
    deletePollsDataSuccess,
    deletePollsDataFailure,


} from "../../slices/pollSlice";

import {
    getCommentModerationFilterLoading,
    getCommentModerationFilterSuccess,
    getCommentModerationFilterFailure,

    getCommentModerationListLoading,
    getCommentModerationListSuccess,
    getCommentModerationListFailure,

    getCommentModerationEditLoading,
    getCommentModerationEditSuccess,
    getCommentModerationEditFailure,

    putCommentModerationSubmitLoading,
    putCommentModerationSubmitSuccess,
    putCommentModerationSubmitFailure,

} from "../../slices/commentMorderation";

//  Title
export const getPollFilterTitleAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollTitleFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollTitleFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollTitleFilterFailure(error.message));
                }
            });
    };
};

// Status
export const getPollFilterStatusAction = (params) => {
    return async (dispatch) => {
      dispatch(getPollStatusFilterLoading());
      try {
        const response = await getPollsFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getPollStatusFilterSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getPollStatusFilterFailure(error.message));
        }
      }
    };
  };

//  Device
export const getPollFilterDeviceAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollDeviceFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollDeviceFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollDeviceFilterFailure(error.message));
                }
            });
    };
};

//  PageType
export const getPollFilterPageTypeAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollPageTypeFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollPageTypeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollPageTypeFilterFailure(error.message));
                }
            });
    };
};

//  EntityType
export const getPollFilterEntityTypeAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollEntityTypeFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollEntityTypeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollEntityTypeFilterFailure(error.message));
                }
            });
    };
};

//  domain type
export const getPollDomainTypeAction= (params) => {
    return async (dispatch) => {
        dispatch(getPollDomainTypeLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollDomainTypeSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollDomainTypeFailure(error.message));
                }
            });
    };
};

//Sub Page 
export const getPollSubPageAction= (params) => {
    return async (dispatch) => {
        dispatch(getPollSubPageLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollSubPageSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollSubPageFailure(error.message));
                }
            });
    };
};

//  entity name
export const getPollFilterEntityNameAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollEntityNameFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollEntityNameFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollEntityNameFilterFailure(error.message));
                }
            });
    };
};
//  Sub Category
export const getPollFilterSubCategoryAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollSubCategoryFilterLoading());
        await getPollsFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollSubCategoryFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollSubCategoryFilterFailure(error.message));
                }
            });
    };
};

// Polls List Action
export const getPollsListAction = (params) => {
    return async (dispatch) => {
        dispatch(getPollsListLoading());
        await getPollsListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollsListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollsListFailure(error.message));
                }
            });
    };
};

//GET POLLS DATA 
export const getPollsDataAction = (data) => {
    return async (dispatch) => {
        dispatch(getPollsDataLoading());
        await getPollsRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getPollsDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPollsDataFailure(error.message));
                }
            });
    };
};

// Add Polls Action
export const postPollsAction = (data) => {
    return async (dispatch) => {
        dispatch(postPollLoading());
        await postPollsRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postPollsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postPollsFailure(error.response?.data));
                }
            });
    };
};

//Update POLLS DATA 
export const putPollsAction = (data) => {
    return async (dispatch) => {
        dispatch(putPollsLoading());
        await putPollsRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(putPollsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putPollsFailure(error.response?.data));
                }
            });
    };
};

// Delete Polls Action 
export const deletePollsAction = (data) => {
    return async (dispatch) => {
        dispatch(deletePollsDataLoading());
        await deletePollsRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(deletePollsDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deletePollsDataFailure(error.response?.data));
                }
            });
    };
};

//comment moderation filter
export const getCommentModerationFilterAction = (params) => {
    return async (dispatch) => {
      dispatch(getCommentModerationFilterLoading());
      try {
        const response = await getCommentModerationFilterRepo(params);
        if (response?.status === 200) {
          dispatch(getCommentModerationFilterSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getCommentModerationFilterFailure(error.message));
        }
      }
    };
  };

  //comment moderation list
export const getCommentModerationListAction = (params) => {
    return async (dispatch) => {
      dispatch(getCommentModerationListLoading());
      try {
        const response = await getCommentModerationListRepo(params);
        if (response?.status === 200) {
          dispatch(getCommentModerationListSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getCommentModerationListFailure(error.message));
        }
      }
    };
  };

  //comment moderation edit
  export const getCommentModerationEditAction = (id, params) => {
    return async (dispatch) => {
      dispatch(getCommentModerationEditLoading());
      try {
        const response = await getCommentModerationEditRepo(id, params);
        if (response?.status === 200) {
          dispatch(getCommentModerationEditSuccess(response?.data?.data));
          return response;
        }
      } catch (error) {
        if (error && error.response) {
          dispatch(getCommentModerationEditFailure(error.message));
        }
      }
    };
  };

  //comment moderation submit
  export const putCommentModerationSubmitAction = (id, params) => {
    return async (dispatch) => {
      dispatch(putCommentModerationSubmitLoading());
      try {
        const response = await putCommentModerationSubmitRepo(id, params);
        if (response?.status === 200) {
          dispatch(putCommentModerationSubmitSuccess(response?.data?.data));
          return { success: true, data: response?.data?.data };
        } else {
          dispatch(putCommentModerationSubmitFailure("Unexpected response"));
          return { success: false, error: "Unexpected response" };
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || "Update failed";
        dispatch(putCommentModerationSubmitFailure(errorMsg));
        return { success: false, error: errorMsg };
      }
    };
  };
  



